export class IterableObject<T, V = T[keyof T]> implements Iterable<[keyof T, V]> {
    constructor(object: T) {
        Object.assign(this, object);
    }

    entries(): IterableIterator<[keyof T, V]> {
        return this[Symbol.iterator]();
    }

    *values(): IterableIterator<V> {
        for (let value of Object.values(this)) {
            yield value;
        }
    }

    *keys(): IterableIterator<keyof T> {
        for (let key of Object.keys(this)) {
            yield key as keyof T;
        }
    }

    *[Symbol.iterator](): IterableIterator<[keyof T, V]> {
        for (let [key, value] of Object.entries(this)) {
            yield [key, value] as [keyof T, V];
        }
    }
}
